module.exports = __webpack_public_path__ + "img/facts-all_1941.9723b600.png";